var Handlebars = require("handlebars/dist/handlebars");
function __default(obj) { return obj && (obj.__esModule ? obj["default"] : obj); }
module.exports = (Handlebars["default"] || Handlebars).template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "\n<h2>Submit And Pay</h2>\n\n<div class=\"row\">\n  <div class=\"col-sm-12 col-md-6\">\n    <div class=\"payment-invoice\"></div>\n  </div>\n</div>";
},"useData":true});